import { render, staticRenderFns } from "./MappingTable.vue?vue&type=template&id=80c348e4&scoped=true&"
import script from "./MappingTable.vue?vue&type=script&lang=js&"
export * from "./MappingTable.vue?vue&type=script&lang=js&"
import style0 from "./MappingTable.vue?vue&type=style&index=0&id=80c348e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c348e4",
  null
  
)

export default component.exports